// extracted by mini-css-extract-plugin
export default {"energyLimit":"styles_energyLimit__2qs0c","iconWrapper":"styles_iconWrapper__+2NoT"};